import classcat from "classcat";
import React from "react";

import { Button } from "@touchtech/web-baselayer-ui";

import { SelectField } from "@is/components/SelectField";

import Modal from "../Modal";
import css from "./LanguageAndCurrencyModal.module.css";
import useManageLanguageAndCurrencyModal from "./hooks/useManageLanguageAndCurrencyModal";

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

const LanguageAndCurrencyModal = ({ isOpen, onClose }: Props) => {
  const {
    selectedLanguage,
    selectedCountry,
    handleSelectLanguage,
    handleSelectCountry,
    handleModalClose,
    handleApply,
    handleCancel,
    languageOrCurrencyChanged,
    availableLanguages,
    availableDeliveryCountries,
    enableCountrySelection,
    t,
  } = useManageLanguageAndCurrencyModal({ onClose });

  return (
    <Modal isOpen={isOpen} onClose={handleModalClose} className={css.modal}>
      <div className={css.modalContent}>
        <h1 className={classcat(["text-headline-5xl", css.title])}>
          {t("Language & country")}
        </h1>
        <span className={classcat(["text-label-xl", css.text])}>
          {t(
            "Set the app’s language and shipping country. This will restart your shopping session."
          )}
        </span>
        <div className={css.selectContainer}>
          <SelectField
            placeholder={t("Language")}
            options={availableLanguages}
            width="640px"
            label={t("Language")}
            onChange={handleSelectLanguage}
            defaultValue={selectedLanguage}
            showSelectedWithTick
          />
          <SelectField
            placeholder={t("Country")}
            options={availableDeliveryCountries}
            width="640px"
            label={t("Country")}
            hasError
            onChange={handleSelectCountry}
            defaultValue={selectedCountry}
            showSelectedWithTick
            disabled={!enableCountrySelection}
          />
        </div>
        <div className={css.buttonContainer}>
          <Button
            width="full"
            className={css.applyButton}
            sizing="lg"
            onClick={handleApply}
            state={!languageOrCurrencyChanged ? "disabled" : undefined}
          >
            {t("Apply")}
          </Button>
          <Button
            width="full"
            className={css.cancelButton}
            sizing="lg"
            onClick={handleCancel}
          >
            {t("Cancel")}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default LanguageAndCurrencyModal;
